import { InputBaseComponentProps, OutlinedInput } from '@mui/material';
import * as React from 'react';
import { FieldError } from 'react-hook-form';
import { InputWrapper } from './Wrapper';

interface Props {
  label: string;
  type: string;
  placeholder?: string;
  inputProps: InputBaseComponentProps;
  error?: FieldError;
  autoFocus?: boolean;
  disabled?: boolean;
  className?: string;
  id?: string;
}

/**
 * Abstraction for our sign in form inputs so we only
 * have to style them once
 */
export const Input: React.FC<Props> = (props) => {
  const { autoFocus, type, id, placeholder, inputProps, disabled, ...rest } = props;
  return (
    <InputWrapper {...rest}>
      <OutlinedInput
        autoFocus={autoFocus}
        type={type}
        id={id}
        placeholder={placeholder}
        fullWidth
        inputProps={inputProps}
        disabled={disabled}
        classes={{ root: 'h-[54px]' }}
      />
    </InputWrapper>
  );
};
Input.displayName = 'SignInput.Input';
